module.exports = __webpack_public_path__ + "static/media/Victini_gaussian2.20506936.png";